export default {
    intro: '根据声母提示和释义来推理词汇吧！',
    meaning: '释义',
    example: '例句',
    table: {
        question: '词汇',
        emptyMessage: '没有内容。',
        answerRate: '正确率',
    },
    student: {
        selectionGuide: '看了这些提示，你能猜出是什么词汇吗？',
        know: '我知道！',
        dontKnow: '不知道',
        submit: '提交',
        next: '下一题',
        inputGuide: '请输入你想到的词汇！',
        inputPlaceholder: '请输入答案',
        meaningN: '释义 {n}',
        imageN: '图片 {n}',
        videoN: '视频 {n}',
        additionalMaterials: '附加资料',
    },
    result: {
        myAnswer: '我的答案：',
        know: '知道',
        dontKnow: '不知道',
        dontKnowBracket: '（不知道）',
    },
    stats: {
        mostIncorrect: '错误最多的词汇',
        vocabulary: '词汇',
        meaning: '释义',
        accuracy: '正确率',
        moreN: '等{n}个',
    },
    reactions: {
        knowSelect: [
            '哦！你很有自信呢！',
            '好的！我们来看看吧！',
            '不错！看看你答对了没有！',
            '厉害！会是什么词汇呢？',
            '很好！一起来看答案吧！',
        ],
        correct: [
            '答对了！真棒！',
            '哇！你完全知道呢！',
            '正确！太厉害了！',
            '太棒了！完全正确！',
            '做得好！真了不起！',
        ],
        dontKnowSelect: [
            '没关系！我们一起来看看吧！',
            '别担心！看看例句就知道了！',
            '没问题！一起看提示吧！',
        ],
    },
};
